import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';
import { PoolModel } from '../../sections/types/PoolModel';

export interface ICreateBaasEdgePoolParams {
  displayName: string;
  DataConnectSettingsVersion: string;
  siteId: string;
}

export interface ICreateBaasEdgePoolResult extends IResult {
  success?: {
    pool: PoolModel;
    siteID: string;
  };
  error?: BaasEdgePoolError;
}

export class CreateBaasEdgePoolRequest extends Request<ICreateBaasEdgePoolParams, ICreateBaasEdgePoolResult> {
  constructor(params: ICreateBaasEdgePoolParams) {
    super('createBaasEdgePool', params);
  }
}
